import { render, staticRenderFns } from "./CustomerInput.vue?vue&type=template&id=cf14fe36&scoped=true&"
import script from "./CustomerInput.vue?vue&type=script&lang=js&"
export * from "./CustomerInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInput.vue?vue&type=style&index=0&id=cf14fe36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf14fe36",
  null
  
)

export default component.exports